import { API } from './constants/api-urls';

export const ENDPOINTS_WITHOUT_LOADER = [
  API.ACCOUNTS_PATH,
  API.CONFIGURATION_PATH,
  API.SENSOR_AUTHORIZATIONS_PATH,
  API.REPOSITORIES_PATH,
  API.ORGANIZATIONS_PATH,
  API.CONTRIBUTORS_PATH,
  API.RESOURCE_ALLOCATION,
  API.JOBS_SUITES_PATH,
  `${API.PDT_PROJECTS}/status-check`,
  `${API.PM_PROJECTS_VIEW}/status`
];
